export const abortMessage = "Upload Cancelled";

export const uploadFile = ({
  uploadUrl,
  file,
  onProgress,
}: {
  uploadUrl: string;
  file: File;
  onProgress: (percent: number) => void;
}) => {
  const request = new XMLHttpRequest();

  const promise = new Promise<void>((resolve, reject) => {
    request.open("PUT", uploadUrl);
    onProgress(0);
    if (request.upload && request.upload.addEventListener) {
      request.upload.addEventListener("progress", (e) => {
        onProgress((e.loaded / e.total) * 100);
      });
    }
    request.addEventListener("error", () => {
      reject(new Error("Upload Failed"));
    });
    request.addEventListener("abort", () => {
      reject(new Error(abortMessage));
    });
    request.addEventListener("load", () => {
      if (request.status === 200) {
        resolve();
      } else {
        reject(new Error(request.responseText));
      }
    });

    request.send(file);
  });

  return {
    promise,
    abort: () => {
      request.abort();
    },
  };
};
